import { MyMaterialsRouteView } from '@/app/routing/root/my-materials/index/view';

export const indexRoute = {
  index: true,
  element: <MyMaterialsRouteView/>,
};